const graphPalette = [
  "#0b5345",
  "#0e6251",
  "#0e6655",
  "#117864",
  "#117a65",
  "#138d75",
  "#145a32",
  "#148f77",
  "#154360",
  "#16a085",
  "#16a085",
  "#17202a",
  "#17a589",
  "#186a3b",
  "#196f3d",
  "#1a5276",
  "#1abc9c",
  "#1abc9c",
  "#1b2631",
  "#1b4f72",
  "#1c2833",
  "#1d8348",
  "#1e8449",
  "#1f618d",
  "#212f3c",
  "#212f3d",
  "#21618c",
  "#229954",
  "#239b56",
  "#2471a3",
  "#273746",
  "#27ae60",
  "#27ae60",
  "#283747",
  "#2874a6",
  "#28b463",
  "#2980b9",
  "#2980b9",
  "#2c3e50",
  "#2c3e50",
  "#2e4053",
  "#2e86c1",
  "#2ecc71",
  "#2ecc71",
  "#34495e",
  "#34495e",
  "#3498db",
  "#3498db",
  "#424949",
  "#45b39d",
  "#48c9b0",
  "#4a235a",
  "#4d5656",
  "#512e5f",
  "#515a5a",
  "#52be80",
  "#5499c7",
  "#566573",
  "#58d68d",
  "#5b2c6f",
  "#5d6d7e",
  "#5dade2",
  "#5f6a6a",
  "#616a6b",
  "#626567",
  "#633974",
  "#641e16",
  "#6c3483",
  "#6e2c00",
  "#707b7c",
  "#717d7e",
  "#73c6b6",
  "#76448a",
  "#76d7c4",
  "#78281f",
  "#784212",
  "#797d7f",
  "#7b241c",
  "#7b7d7d",
  "#7d3c98",
  "#7d6608",
  "#7dcea0",
  "#7e5109",
  "#7f8c8d",
  "#7f8c8d",
  "#7fb3d5",
  "#808b96",
  "#82e0aa",
  "#839192",
  "#85929e",
  "#85c1e9",
  "#873600",
  "#884ea0",
  "#8e44ad",
  "#8e44ad",
  "#909497",
  "#922b21",
  "#935116",
  "#943126",
  "#95a5a6",
  "#95a5a6",
  "#979a9a",
  "#99a3a4",
  "#9a7d0a",
  "#9b59b6",
  "#9b59b6",
  "#9c640c",
  "#a04000",
  "#a2d9ce",
  "#a3e4d7",
  "#a569bd",
  "#a6acaf",
  "#a93226",
  "#a9cce3",
  "#a9dfbf",
  "#aab7b8",
  "#abb2b9",
  "#abebc6",
  "#aeb6bf",
  "#aed6f1",
  "#af601a",
  "#af7ac5",
  "#b03a2e",
  "#b2babb",
  "#b3b6b7",
  "#b7950b",
  "#b9770e",
  "#ba4a00",
  "#bb8fce",
  "#bdc3c7",
  "#bdc3c7",
  "#bfc9ca",
  "#c0392b",
  "#c0392b",
  "#c39bd3",
  "#ca6f1e",
  "#cacfd2",
  "#cb4335",
  "#ccd1d1",
  "#cd6155",
  "#d0d3d4",
  "#d0ece7",
  "#d1f2eb",
  "#d2b4de",
  "#d35400",
  "#d35400",
  "#d4ac0d",
  "#d4e6f1",
  "#d4efdf",
  "#d5d8dc",
  "#d5dbdb",
  "#d5f5e3",
  "#d68910",
  "#d6dbdf",
  "#d6eaf8",
  "#d7bde2",
  "#d7dbdd",
  "#d98880",
  "#dc7633",
  "#e59866",
  "#e5e7e9",
  "#e5e8e8",
  "#e67e22",
  "#e67e22",
  "#e6b0aa",
  "#e74c3c",
  "#e74c3c",
  "#e8daef",
  "#e8f6f3",
  "#e8f8f5",
  "#e9f7ef",
  "#eaecee",
  "#eaeded",
  "#eaf2f8",
  "#eafaf1",
  "#eb984e",
  "#ebdef0",
  "#ebedef",
  "#ebf5fb",
  "#ec7063",
  "#ecf0f1",
  "#ecf0f1",
  "#edbb99",
  "#f0b27a",
  "#f0f3f4",
  "#f1948a",
  "#f1c40f",
  "#f1c40f",
  "#f2d7d5",
  "#f2f3f4",
  "#f2f4f4",
  "#f39c12",
  "#f39c12",
  "#f4d03f",
  "#f4ecf7",
  "#f4f6f6",
  "#f4f6f7",
  "#f5b041",
  "#f5b7b1",
  "#f5cba7",
  "#f5eef8",
  "#f6ddcc",
  "#f7dc6f",
  "#f7f9f9",
  "#f8c471",
  "#f8f9f9",
  "#f9e79f",
  "#f9ebea",
  "#fad7a0",
  "#fadbd8",
  "#fae5d3",
  "#fbeee6",
  "#fbfcfc",
  "#fcf3cf",
  "#fdebd0",
  "#fdedec",
  "#fdf2e9",
  "#fdfefe",
  "#fef5e7",
  "#fef9e7",
]

export default graphPalette
